import { Dispatch } from 'react';
import api from '../../../api/api';
import { TLongLivetoken, TMetaActionTypes } from '../types';
import { SET_LOADING } from 'src/contexts/types';
import { handleError } from 'src/contexts/utils/handleError';
import { HEADERS } from 'src/constants/headers';
import { getExpirationDate } from 'src/components/Stores/utils/getExpirationDate';

export const getLongLiveToken = async (
    dispatch: Dispatch<TMetaActionTypes>,
    values: TLongLivetoken
) => {
    dispatch({ type: SET_LOADING });
    try {
        const res = await api.post('/meta/long-live-token', values, HEADERS());
        const tokenData = {
            token: res?.data?.access_token || '',
            expires_in: getExpirationDate(res?.data?.expires_in) || '',
        };

        return tokenData;
    } catch (error) {
        const err: any = error;
        dispatch(handleError(err));
    }
};
